var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[_c('van-icon',{attrs:{"name":"smile-o","color":"#ddd","size":"70"}}),_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("页面不存在")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }